import React, { memo } from 'react'
import { useFormContext } from 'react-hook-form'

import { DefaultFormField } from '@surglogs-app/ui.form'

import { useAccountSettingsTranslation } from '../services'

import { PinFormGroup } from './PinFormGroup'
import { SettingsUserEditPinInput } from './SettingsUserEditPinInput'

interface SettingsUserEditPinModalFormPinProps {
  pinLength: number
}

export const SettingsUserEditPinModalFormPin = memo(
  ({ pinLength }: SettingsUserEditPinModalFormPinProps) => {
    const { t } = useAccountSettingsTranslation()
    const {
      control,
      formState: { errors },
    } = useFormContext()

    return (
      <DefaultFormField
        {...{
          t,
          name: 'pin',
          label: t('pin_label' as any, { length: pinLength }),
        }}>
        <PinFormGroup
          {...{
            name: 'pin',
            errors,
            control,
            component: SettingsUserEditPinInput,
          }}
        />
      </DefaultFormField>
    )
  },
)
